export default "/build/images/030-3-300x300.png?358d4b7ea2d2adea54c13a7be2a3c92c";